module.exports = __webpack_public_path__ + "static/media/thumbnail_ally-ups-drape@3x.867e093c.jpg";